import 'luxon';

declare global {
    interface Number {
        paraListaNumerica(): Array<{ valor?: number | string, rotulo: string }>;
        moeda(): string;
        segundosParaTempo(): string;
        toHumanFileSize(): string;
    }
}

Number.prototype.paraListaNumerica = function()
{
    const lista: Array<{
        valor?: number | string,
        rotulo: string
    }> = [];

    Array.from(Array(this), (x,i) => {
        const valor = i + 1;

        lista.push({ valor, rotulo: valor.toString() });
    });

    return lista;
}

Number.prototype.moeda = function()
{
    return `R$${this.toFixed(2)}`;
}

Number.prototype.segundosParaTempo = function()
{
    const sec_num = parseInt(this.toString(), 10);

    let hours = (Math.floor(sec_num / 3600)).toString();
    let minutes = (Math.floor((sec_num - (parseInt(hours) * 3600)) / 60)).toString();
    let seconds = (sec_num - (parseInt(hours) * 3600) - (parseInt(minutes) * 60)).toString();

    if (parseInt(hours) < 10) hours = '0' + hours;
    if (parseInt(minutes) < 10) minutes = '0' + minutes;
    if (parseInt(seconds) < 10) seconds = '0' + seconds;

    return hours+':'+minutes+':'+seconds;
}

/**
 * Format bytes as human-readable text.
 *
 * @param {number} bytes Number of bytes.
 * @param {number} dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
 Number.prototype.toHumanFileSize = function(dp = 1) {
  let bytes = this as number;
  const thresh = 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


  return bytes.toFixed(dp) + ' ' + units[u];
}
